const getMultilevelSensorStateDescription = (sensorType: string, sensorValue: string): string => {
  if (!sensorType) {
    throw new Error('sensor unsupported')
  }
  return `${sensorType.toLowerCase()} is detected ${sensorValue}`
}

export default getMultilevelSensorStateDescription
